export enum TractorStatus {
  Available = 0,
  Shop = 1,
  OOS = 2,
}

export class TractorViewModel {
  id: string | number;
  dateCreatedUtc: string;
  dateDeletedUtc: string;
  isActive: boolean;
  status: TractorStatus = TractorStatus.Available;
  unitNumber: string;
  model: string;
  terminalLocation: string;
  make: string;
  owner: string;
  fuelType: string;
  licenseNumber: string;
  stateOfRegistration: string;
  height: string;
  length: string;
  width: string;
  axles: string;
  insuranceName: string;
  insurancePolicyNumber: string;
  equipmentCode: string;
  picture: string;
  mobileDeviceType: string;
  mobileDeviceNumber: string;
  engineManufacturer: string;
  engineSerialNumber: string;
  engineModel: string;
  afterTreatmentManufactureWarranty: string;
  engineManufactureWarranty: string;
  baseManuFactureWarranty: string;
  tchekCardNo: string;
  vinNo: string;
  notes: string;
  year: number;
  afterTreatmentYearWarranty: number;
  afterTreatmentMilesWarranty: number;
  engineYearWarranty: number;
  engineMilesWarranty: number;
  baseWarrantyYear: number;
  baseWarrantyMiles: number;
  accumulatedMiles: number;
  purchasePrice: number;
  ladenWeight: number;
  unladenWeight: number;
  steerTireSize: number;
  driveTireSize: number;
  licenseExpirationDate: Date;
  datePurchased: Date;
  dateSold: Date;
  nextServiceDate: Date;
  driverId: string;
  currentLocationCity?: string | null;
  currentLocationState?: string | null;
  /** When PeopleNet location was last updated (from PeopleNetTractorLocations). */
  peopleNetLocationUpdatedUtc?: Date;

  driver?: any;
}
